import { Skeleton } from 'antd';

interface CardLoadingProps {
  className?: string;
}

export function CardSkeleton({ className = '' }: Readonly<CardLoadingProps>) {
  return (
    <div
      className={`flex-shrink-0 sm:w-[176px] min-w-[160px] rounded-xl border p-4 bg-wl-background border-wl-on-background opacity-10 ${className}`}
    >
      <Skeleton
        active
        title
        paragraph={{ rows: 3 }}
        className='dark:bg-gray-200'
      />
    </div>
  );
}
